import { render, staticRenderFns } from "./ProductVariantAddEditModal.vue?vue&type=template&id=3f43ffab&scoped=true&"
import script from "./ProductVariantAddEditModal.vue?vue&type=script&lang=js&"
export * from "./ProductVariantAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantAddEditModal.vue?vue&type=style&index=0&id=3f43ffab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43ffab",
  null
  
)

export default component.exports